import type { App } from 'vue'
import { vId } from '@sozialinfo/kompass'

export default (app: App) => {
  app.directive('id', vId)
}
